export const topExtend = function () {
	document.addEventListener("DOMContentLoaded", () => {
		infinite();
	});
	function infinite() {
		const marquee = document.querySelectorAll('.marquee');
		if (marquee) {
			marquee.forEach((element, index) => {
				element.classList.add(`marquee${index}`)
				const marqueeInner = element.querySelector('.marquee__inner');
				const logos = [...marqueeInner.children];
				const logoSetWidth = 150 * logos.length; // 画像の幅が150pxとして計算
			
				// 必要なクローンセット数を計算
				const numberOfClones = Math.ceil((element.offsetWidth - logoSetWidth) / logoSetWidth) + 1;
			
				// 必要なセット数だけクローンを作成
				for (let i = 0; i < numberOfClones; i++) {
					logos.forEach(logo => marqueeInner.appendChild(logo.cloneNode(true)));
				}
				// アニメーションの更新
				const animationCSS = `
				.marquee${index} .animate {
					animation: marquee${index} 10s linear infinite;
				}
				@keyframes marquee${index} {
					0% \{ transform: translateX(0); }
					100% \{ transform: translateX(-` + logoSetWidth + `px); }
				}
				`;
				const styleElem = document.createElement('style');
				styleElem.textContent = animationCSS;
				document.head.appendChild(styleElem);
			});
		}
	}
}
